import {
  Stethoscope, XCircle, RefreshCw, Plane, PlaneTakeoff, Hotel, Building2, ClipboardCheck, Users,
  ShieldCheck, Award, Clock, Headset, Zap, LockKeyhole, BadgeCheck, HeartHandshake, Globe2,
  FileCheck2, CreditCard, Star, ThumbsUp, MapPin, Phone, Mail, MessageCircle, CheckCircle2,
  Compass, Luggage, Ticket, Building, UserCheck, Timer, Wallet, CalendarCheck, Send, Sparkles,
  Rocket, Fingerprint, Landmark,
} from "lucide-react";

export const ICON_LIBRARY = {
  Stethoscope, XCircle, RefreshCw, Plane, PlaneTakeoff, Hotel, Building2, ClipboardCheck, Users,
  ShieldCheck, Award, Clock, Headset, Zap, LockKeyhole, BadgeCheck, HeartHandshake, Globe2,
  FileCheck2, CreditCard, Star, ThumbsUp, MapPin, Phone, Mail, MessageCircle, CheckCircle2,
  Compass, Luggage, Ticket, Building, UserCheck, Timer, Wallet, CalendarCheck, Send, Sparkles,
  Rocket, Fingerprint, Landmark,
};

export const ICON_NAMES = Object.keys(ICON_LIBRARY);

export function getIcon(name) {
  return ICON_LIBRARY[name] || Sparkles;
}
